// extracted by mini-css-extract-plugin
module.exports = {"curve":"style_curve__l05no"};